const values = Object.freeze({
  EvaluatedResults: 1,
  WhodasCifCodes: 2,
  EvaluatedMainTasks: 3,
  CirinoArciInventory: 4,
  LearningStyles: 5,
  Riasec: 8,
  InterestAreas: 9,
  WorkerFunctions: 14,
  Temperaments: 15,
  EnvironmentalWorkConditions: 16,
  PhysicalDemandsForce: 17,
  PhysicalDemandsPhysicalMovements: 20,
  SchoolRecommendations: 21,
  TutorsRecommendations: 22,
  SchoolRecommendationsSchool: 23,
  TutorsRecommendationsTutors: 24,
  SchoolTutorsRecommendationsStudent: 25,
});

export default values;
